export const validComponents = [
    'IntroParagraph',
    'SubHeader',
    'ParagraphText',
    'BoldParagraphText',
    'ConclusionText',
    'List',
    'Quote',
    'ProConsHeader',
    'ProConsTable',
    'ArticleTip',
    'NumberedList',
    'InterlinkingBox',
    'InterlinkingCarousel',
    'GammaCarousel',
    'CtaButton',
    'TopProviderCta',
    'Sources',
    'ArticleImage',
    'ContentsTable',
    'ArticleRankings',
    'HighlightedTopProvider',
    'TopProviderDiscount',
    'ProviderDiscount',
    'DetailedProviderRow',
    'CompadoArticleRankings', // fallback component
    'SidebarRanking',
    'QuickGuide',
    'SubSubHeader',
    'SubSubSubHeader',
    'SimpleTable',
    'ComparisonTable',
    'GamesEmbed',
    'VideoEmbed',
    'AdsenseWidget',
    'ConversionCowboysWidget',
];

export const rankingComponents = [
    'article_rankings',
    'highlighted_top_provider',
    'top_provider_discount',
    'provider_discount',
    'top_provider_cta',
    'sidebar_ranking',
    'detailed_provider_row',
    'comparison_table',
];
